"use client";

import { axiosAdmin } from "@/lib/axios";
import { useGenericMutation } from "@/components/query/useGenericMutation";

export const useAddToCart = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.post("/user/cart/add", data),
    onSuccessMessage: "Item Added to Cart",
    queryKeyToInvalidate: ["getcart"],
  });
};

export const useBulkAddToCart = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.post("/user/cart/bulk-add", data),
    onSuccessMessage: "Combo bundle added to cart!",
    queryKeyToInvalidate: ["getcart"],
  });
};

export const useRemoveFromCart = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.post("/user/cart/remove", data),
    onSuccessMessage: "Item Removed from Cart",
    queryKeyToInvalidate: ["getcart"],
    // redirectTo: "/dashboard/carousel/list"
  });
};

export const useClearAllFromCart = () => {
  return useGenericMutation<any>({
    apiCall: () => axiosAdmin.delete("/user/cart/clear",),
    disableSuccessToast: true,
    queryKeyToInvalidate: ["getcart"],
    // redirectTo: "/dashboard/carousel/list"
  });
};


export const useUpdateCartQuantity = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.put("/user/cart/update", data),
    onSuccessMessage: "Cart Quantity Updated",
    queryKeyToInvalidate: ["getcart"],
    // redirectTo: "/dashboard/carousel/list"
  });
};

export const useCreateAddress = () => {
  return useGenericMutation<any>({
    apiCall: (data) => axiosAdmin.post("/user/addresses", data),
    onSuccessMessage: "Address Created",
    queryKeyToInvalidate: ["getAddresses"],
    // redirectTo: "/dashboard/carousel/list"
  });
};


export const useEditAddress = (id?:any) => {
  return useGenericMutation<any>({
    apiCall: (data:any) => axiosAdmin.put(`/user/addresses/${id}`, data),
    onSuccessMessage: "Address Edit done",
    queryKeyToInvalidate: ["getAddresses"],
  });
};

export const useDeleteAddress = () => {
  return useGenericMutation<any>({
    apiCall: (id: any) => axiosAdmin.delete(`/user/addresses/${id}`),
    onSuccessMessage: "Address deleted successfully",
    queryKeyToInvalidate: ["getAddresses"],
  });
};